/** 播種推奨度の定数マップ */
export const SEEDING_RECOMMENDATION = {
  RECOMMENDED: 'recommended', // 推奨
  CAUTION: 'caution', // 要注意
  NOT_RECOMMENDED: 'not_recommended', // 非推奨
} as const;

/** 播種推奨度の型（SEEDING_RECOMMENDATION の値から導出） */
export type SeedingRecommendation =
  (typeof SEEDING_RECOMMENDATION)[keyof typeof SEEDING_RECOMMENDATION];

/**
 * 播種推奨度のシンボル定数
 */
export const SEEDING_SYMBOLS = {
  RECOMMENDED: '○', // 推奨
  CAUTION: '▲', // 要注意
  NOT_RECOMMENDED: '×', // 非推奨
} as const;

/**
 * 播種推奨度のシンボル型（定数から自動生成）
 */
export type SeedingSymbol = (typeof SEEDING_SYMBOLS)[keyof typeof SEEDING_SYMBOLS];

/**
 * デフォルトの播種シンボル（推奨）
 */
export const DEFAULT_SEEDING_SYMBOL: SeedingSymbol = SEEDING_SYMBOLS.RECOMMENDED;

/** 播種推奨度の表示設定インターフェース */
export interface SeedingRecommendationConfig {
  label: string; // 表示ラベル
  symbol: SeedingSymbol; // 表示記号（○、▲、×）
  description: string; // 説明
}

/** 播種推奨度ごとの表示設定マップ */
export const SEEDING_RECOMMENDATION_CONFIG: Record<
  SeedingRecommendation,
  SeedingRecommendationConfig
> = {
  [SEEDING_RECOMMENDATION.RECOMMENDED]: {
    label: '推奨',
    symbol: SEEDING_SYMBOLS.RECOMMENDED,
    description: '播種に適した時期です',
  },
  [SEEDING_RECOMMENDATION.CAUTION]: {
    label: '要注意',
    symbol: SEEDING_SYMBOLS.CAUTION,
    description: '播種可能ですが注意が必要です',
  },
  [SEEDING_RECOMMENDATION.NOT_RECOMMENDED]: {
    label: '非推奨',
    symbol: SEEDING_SYMBOLS.NOT_RECOMMENDED,
    description: '播種に適さない時期です',
  },
};

/**
 * 播種推奨度に応じた記号を取得するヘルパー関数
 * @param recommendation 播種推奨度
 * @returns 播種推奨度に対応する記号（○、▲、×）
 */
export function getSeedingRecommendationSymbol(
  recommendation: SeedingRecommendation
): SeedingSymbol {
  return SEEDING_RECOMMENDATION_CONFIG[recommendation].symbol;
}

/**
 * 播種推奨度に応じたラベルを取得するヘルパー関数
 * @param recommendation 播種推奨度
 * @returns 播種推奨度の日本語ラベル
 */
export function getSeedingRecommendationLabel(recommendation: SeedingRecommendation): string {
  return SEEDING_RECOMMENDATION_CONFIG[recommendation].label;
}
